module.exports = __webpack_public_path__ + "img/pf.00d22a22.svg";